import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jsmWorkItemRoute: InvariantJiraRoute = {
	name: 'jsm-work-item',
	exact: true,
	path: '/browse/jsm-work-item/:issueKey',
};
